<template>
  <div class="wizard-body w-[75%] flex-shrink-0 flex-grow-0 max-w-[75%]">
    <div v-if="successMessage" v-show="showSuccessMessage" class="overlay">
      <div class="success-popup">
        <span class="close-button" @click="closeSuccessMessage">&times;</span>
        {{ successMessage }}
      </div>
    </div>

    <div class="header-container">
      <h4 class="text-lg font-medium text-black-900 dark:text-slate-200">
        Create Smartflo Inbox
      </h4>
    </div>

    <form @submit.prevent="createChannel">
      <div class="form-fields">
        <!-- Inbox Name Field -->
        <div class="form-group">
          <label :class="{ error: $v.name.$error }">
            Inbox Name
            <input
              v-model="name"
              class="inbox_name"
              type="text"
              placeholder="Enter inbox name here .."
              @blur="$v.name.$touch()"
            />
            <span v-if="$v.name.$error" class="message">
              Inbox name is required.
            </span>
          </label>
        </div>

        <!-- Smartflo Details Section -->
        <div class="smartflo-setup">
          <h6 class="text-sm font-semibold text-black-800 dark:text-slate-300">
            Setup Smartflo Details
          </h6>
          <p class="text-sm text-gray-600 dark:text-gray-400">
            Please enter the required details to configure the Smartflo Inbox.
          </p>
        </div>

        <!-- Smartflo Input Fields with Validation -->
        <div
          v-for="(value, key) in smartfloDetails"
          :key="key"
          class="form-group"
        >
          <label :class="{ error: $v.smartfloDetails[key].$error }">
            {{ fieldLabels[key] || key }}
            <input
              v-model="smartfloDetails[key]"
              type="text"
              class="input"
              :placeholder="`Enter ${fieldLabels[key] || key}`"
              @blur="$v.smartfloDetails[key].$touch()"
            />
            <span v-if="$v.smartfloDetails[key].$error" class="message">
              {{ `${fieldLabels[key]} is required.` }}
            </span>
          </label>
        </div>
      </div>

      <button type="submit" :disabled="$v.$invalid">
        Create Inbox
      </button>
    </form>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import router from '../../../../index';

export default {
  data() {
    return {
      name: '',
      successMessage: '',
      showSuccessMessage: true,
      account_id: this.accountId,
      smartfloDetails: {
        api_token: '',
        caller_id: '',
      },
      fieldLabels: {
        api_token: 'API Token',
        caller_id: 'Caller ID (DID)',
      },
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
    }),
  },
  validations: {
    name: { required },
    smartfloDetails: {
      api_token: { required },
      caller_id: { required },
    },
  },
  methods: {
    async createChannel() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      try {
        const smartfloChannel = await this.$store.dispatch(
          'inboxes/createSmartfloChannel',
          {
            smartflo: {
              type: 'smartflo',
              name: this.name,
              accountId: this.accountId,
              smartflo_details: { ...this.smartfloDetails },
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: smartfloChannel.id,
          },
        });
      } catch (error) {
        this.errorMessage =
          error?.message || 'Failed to create Smartflo channel';
      }
    },
    closeSuccessMessage() {
      this.showSuccessMessage = false;
      this.successMessage = '';
    },
  },
};
</script>

<style scoped>
label {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: 16px;
}

.inbox_name,
.input {
  width: 70%;
}

.input {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.message {
  color: red;
  font-size: 0.875rem;
}

.smartflo-setup {
  margin-bottom: 1rem;
  padding: 10px;
  background-color: #f8f9fa;
  border-left: 4px solid #007bff;
  border-radius: 4px;
}

button:disabled {
  background-color: gray;
  cursor: not-allowed;
}

button {
  margin-top: 1rem;
  cursor: pointer;
  background-color: hsl(209 100% 60.6% / 1);
  color: #fff;
  padding: 10px;
  border-radius: 5px;
  border: none;
  font-size: 1rem;
  width: 20%;
}

.overlay {
  position: fixed;
  margin: auto;
  left: 50%;
  transform: translateX(-50%);
  top: 10%;
  width: 250px;
}

.success-popup {
  background-color: #44ce4b;
  color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  position: relative;
}

.close-button {
  position: absolute;
  top: 5px;
  right: 10px;
  cursor: pointer;
  font-size: 20px;
}
</style>
